import { reducerRegistry } from '../../../../reducerRegistry';

import listsReducersMap from './lists/reducersMap';
import collectionsReducersMap from './collections/reducersMap';

const combineMap = {
  lists: listsReducersMap,
  collections: collectionsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('specialPages', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/specialPages/reducers/static/combineRegistry.js